import Turnos from '../../components/Home/cards/Turnos'
import Form from './cards/Formulario'
//import Consulta from './cards/Consulta'
import Abonar from './cards/Abonar'
//import Esperar from './cards/Esperar'
const NextSteps = ():JSX.Element => {
    return (
      <div className='bg-bgSteps p-12'>
        <div className='flex flex-col justify-center items-center bg-bgSteps pt-2'>
            <h1 className="text-[20px] text-black font-roboto sm:text-[28px]">Ahora si ya podes crearte una cuenta con nosotras y sacar turno</h1>
            <div className='w-20 h-0.5 bg-background_home'></div>
        </div>        
      
      <div className='bg-bgSteps flex justify-center mt-8'>
        <div className='flex flex-wrap justify-start sm:space-x-20 sm:mt-8 mt-4 '>
           
            <div className='sm:ml-20 sm:w-1/4 w-full  flex justify-center'>
            <Turnos/> 
            </div>

            <div className='sm:ml-20 sm:w-1/4 w-full  flex justify-center'>
            <Form/> 
            </div>


            <div className='sm:w-1/4 w-full  flex justify-center'>
            <Abonar/> 
            </div>
           
        </div>   


        </div>
        </div>
    )
}


export default NextSteps